import { SimplePopoverPlainOption } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getChannelsStore } from '@/store/channels/actions';
import useMobile from '@/services/hooks/useMobile';

export const useChannelsOptions = (): SimplePopoverPlainOption[] => {
    const channelsState = useSelector(getChannelsStore);
    const { t } = useTranslation();
    const isMobile = useMobile();

    const { channels, loading } = channelsState;

    if (loading) {
        if (isMobile) {
            return [];
        }
        return [{ label: t('loading'), value: 'loading', disabled: true }];
    }
    if (channels?.length) {
        return channels.map((item) => ({ label: item.Name, value: item.Name }));
    }
    if (isMobile && !channels?.length) {
        return [];
    }
    return [{ label: `0 ${t('results')}`, value: 'noresults', disabled: true }];
};
